import en from './en.json';

export const i18nMessages = {
  en,
};
